import { DeviceTypeEnum } from 'Types/deviceTypes'
import {
  type ImagePlaceholderTypes,
  ImagePlaceholderTypesEnum,
} from 'Types/imagePlaceholders.type'

import newOrderFlowPlaceholder from 'Assets/images/everphonebox.png'

const PLACEHOLDER_BASE_URL =
  'https://assets.everphone.app/portal-assets/placeholders/'

export const PLACEHOLDER_PHONE_PLAN = `${PLACEHOLDER_BASE_URL}simcard.svg`
export const PLACEHOLDER_REQUESTS = `${PLACEHOLDER_BASE_URL}messages.svg`
export const PLACEHOLDER_SMARTPHONE = `${PLACEHOLDER_BASE_URL}mobile.svg`
export const PLACEHOLDER_TABLET = `${PLACEHOLDER_BASE_URL}tablet.svg`
export const PLACEHOLDER_LAPTOP = `${PLACEHOLDER_BASE_URL}laptop.svg`
export const PLACEHOLDER_ACCESSORY = `${PLACEHOLDER_BASE_URL}accessory.svg`
export const PLACEHOLDER_NEW_ORDER_FLOW = newOrderFlowPlaceholder

export const IMAGE_PLACEHOLDER_MAP: Record<ImagePlaceholderTypes, string> = {
  [ImagePlaceholderTypesEnum.phonePlan]: PLACEHOLDER_PHONE_PLAN,
  [ImagePlaceholderTypesEnum.requests]: PLACEHOLDER_REQUESTS,
  [ImagePlaceholderTypesEnum.newOrderFlow]: PLACEHOLDER_NEW_ORDER_FLOW,
  [DeviceTypeEnum.headset]: PLACEHOLDER_ACCESSORY,
  [DeviceTypeEnum.keyboard]: PLACEHOLDER_ACCESSORY,
  [DeviceTypeEnum.laptop]: PLACEHOLDER_LAPTOP,
  [DeviceTypeEnum.monitor]: PLACEHOLDER_ACCESSORY,
  [DeviceTypeEnum.mouse]: PLACEHOLDER_ACCESSORY,
  [DeviceTypeEnum.other]: PLACEHOLDER_ACCESSORY,
  [DeviceTypeEnum.printer]: PLACEHOLDER_ACCESSORY,
  [DeviceTypeEnum.smartphone]: PLACEHOLDER_SMARTPHONE,
  [DeviceTypeEnum.tablet]: PLACEHOLDER_TABLET,
  [DeviceTypeEnum.accessory]: PLACEHOLDER_ACCESSORY,
}
